import React from 'react';
import { ButtonBase, Box, makeStyles } from '@material-ui/core';
import { classNames } from '../../utils';

const useStyles = makeStyles(() => ({
  tab: ({ width, p }) => ({
    width,
    height: '3.875rem',
    borderRadius: '10px 10px 0 0',
    fontFamily: 'NotoSans-Bold',
    fontSize: '1rem',
    color: '#538FFF',
    padding: p,
  }),
  selected: {
    backgroundColor: '#FFF',
  },
  unselected: {
    color: '#538fff88',
    backgroundColor: '#538fff11',
  },
}));

const Tab = ({ tabs = [], value, onChange = () => {}, width = '10rem', p = '0' }) => {
  const classes = useStyles({ width, p });

  return (
    <Box display="flex" gridGap="0.625rem">
      {tabs.map((item) => (
        <ButtonBase
          className={classNames(classes.tab, value === item.value ? classes.selected : classes.unselected)}
          onClick={() => onChange(item.value)}
          key={item.value}
        >
          {item.text}
        </ButtonBase>
      ))}
    </Box>
  );
};

export default Tab;
